import React, { useState } from 'react';
import axios from 'axios';
import { TESTIDS } from '@/lib/testIds';
import { Bee, Sun } from './Illustrations';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [status, setStatus] = useState('idle'); // idle | loading | success | error
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setStatus('loading');
    setError('');
    try {
      await axios.post(`${API}/newsletter/subscribe`, { email: email.trim(), name: name.trim() || null });
      setStatus('success');
      setEmail('');
      setName('');
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === 'string' ? detail : 'Please enter a valid email.');
      setStatus('error');
    }
  };

  return (
    <section
      data-testid={TESTIDS.newsletter.section}
      className="relative py-24 md:py-32 bg-[#FBF7F2]"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <div className="relative bg-[#F5C857] rounded-[36px] p-10 md:p-16 shadow-[0_30px_60px_-20px_rgba(245,200,87,0.55)] overflow-hidden">
          {/* deco */}
          <Sun className="absolute -top-6 -right-6 w-28 opacity-70" />
          <Bee className="absolute bottom-6 -left-6 w-24 animate-float-tiny" />
          <div className="absolute -bottom-16 right-10 w-64 h-64 bg-[#FBE8EE] blob-shape-1 opacity-50" />

          <div className="relative text-center max-w-xl mx-auto">
            <p className="font-accent text-3xl text-[#24385C]">Join the Hive</p>
            <h2 className="font-heading text-4xl md:text-5xl text-[#24385C] mt-2 leading-tight">
              Stay abuzz of new developments.
            </h2>
            <p className="mt-5 font-body text-[#24385C]/85 text-[17px] leading-relaxed">
              New books, family activities, reading inspiration, author updates, and thoughtful
              resources to support the growing hearts in your life.
            </p>

            {status === 'success' ? (
              <div
                data-testid={TESTIDS.newsletter.success}
                className="mt-8 bg-white/90 rounded-2xl p-6 border-2 border-white"
              >
                <p className="font-accent text-3xl text-[#8D68B2]">Thank you, friend!</p>
                <p className="mt-2 font-body text-[#24385C]/80">
                  Your seat on the bench is saved. Keep an eye on your inbox soon.
                </p>
              </div>
            ) : (
              <form onSubmit={submit} className="mt-8 flex flex-col gap-3">
                <input
                  data-testid={TESTIDS.newsletter.nameInput}
                  type="text"
                  placeholder="Your first name (optional)"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="w-full bg-white/95 border-2 border-white focus:border-[#8D68B2] rounded-full px-6 py-4 font-body text-[#24385C] placeholder-[#24385C]/45 outline-none transition-all"
                />
                <div className="flex flex-col sm:flex-row gap-3">
                  <input
                    data-testid={TESTIDS.newsletter.emailInput}
                    type="email"
                    required
                    placeholder="you@yourgarden.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="flex-1 bg-white/95 border-2 border-white focus:border-[#8D68B2] rounded-full px-6 py-4 font-body text-[#24385C] placeholder-[#24385C]/45 outline-none transition-all"
                  />
                  <button
                    data-testid={TESTIDS.newsletter.submitBtn}
                    type="submit"
                    disabled={status === 'loading'}
                    className="bg-[#24385C] hover:bg-[#8D68B2] disabled:opacity-60 text-white rounded-full px-8 py-4 font-body font-semibold shadow-md hover:shadow-lg transition-all whitespace-nowrap"
                  >
                    {status === 'loading' ? 'Subscribing…' : 'Subscribe'}
                  </button>
                </div>
                {status === 'error' && (
                  <p className="font-body text-sm text-[#8D68B2] mt-1">{error}</p>
                )}
                <p className="font-body text-xs text-[#24385C]/60 mt-1">
                  No spam. Unsubscribe anytime.
                </p>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
